<template>
  <com-page>
    <com-card>
      <div class="mb-15px">
        <h3 v-if="type === 'created'">创建网点</h3>
        <h3 v-if="type === 'edit'">编辑网点</h3>
        <div class="mb-20px" v-if="type === 'watch'">
          <el-tabs v-model="activeName">
            <el-tab-pane label="基本信息" name="1"></el-tab-pane>
            <el-tab-pane label="设备管理" name="2"></el-tab-pane>
            <el-tab-pane label="订单管理" name="3"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="site-edit_wrapper" v-if="activeName === '1'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
          <el-form-item label="网点图片" prop="photo">
            <com-upload
              :disabled="disabled"
              :originData="ruleForm.photo"
              @postImage="postImg"
              @deleteImageUrl="delImg"
            ></com-upload>
          </el-form-item>
          <el-form-item label="网点密码" prop="pwd">
            <el-input
              v-model="ruleForm.pwd"
              :disabled="disabled"
              placeholder="请输入网点密码"
              style="width: 500px"
            ></el-input>
          </el-form-item>
          <el-form-item label="网点名称" prop="name">
            <el-input
              v-model="ruleForm.name"
              :disabled="disabled"
              placeholder="请输入网点名称"
              style="width: 500px"
            ></el-input>
          </el-form-item>
          <el-form-item label="网点编号">
            <el-input
              v-model="ruleForm.number"
              :disabled="disabled"
              placeholder="请输入网点编号"
              style="width: 500px"
            ></el-input>
          </el-form-item>
          <el-form-item label="生效时间" prop="effectiveTime">
            <el-date-picker
              :disabled="disabled"
              v-model="ruleForm.effectiveTime"
              type="date"
              format="yyyy-MM-dd"
              placeholder="生效时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 500px"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="到期时间" prop="expireTime">
            <el-date-picker
              v-model="ruleForm.expireTime"
              type="date"
              :disabled="disabled"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="到期时间"
              style="width: 500px"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="负责人" prop="projectLeader">
            <el-input
              v-model="ruleForm.projectLeader"
              :disabled="disabled"
              placeholder="请输入负责人"
              style="width: 500px"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="contactNumber">
            <el-input
              v-model="ruleForm.contactNumber"
              :disabled="disabled"
              placeholder="请输入联系方式"
              style="width: 500px"
            ></el-input>
          </el-form-item>
          <el-form-item label="网点类型" prop="type">
            <el-select
              v-model="ruleForm.type"
              :disabled="disabled"
              placeholder="请选择网点类型"
              style="width: 500px"
            >
              <el-option
                :label="item.name"
                :value="item.code"
                v-for="(item, index) in siteType"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在地域" prop="area">
            <com-region
              :regionId.sync="regionId"
              :disabled="disabled"
              :region.sync="region"
              width="500"
            ></com-region>
          </el-form-item>
          <el-form-item label="网点地址" prop="address">
            <div>
              <el-input
                v-model="ruleForm.address"
                disabled
                placeholder="请输入网点地址"
                @change="handleAddress"
                style="width: 500px"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="充值套餐" prop="refChargePlanBatch">
            <el-select
              v-model="ruleForm.refChargePlanBatch"
              :disabled="disabled"
              placeholder="请选择充值套餐"
              style="width: 500px"
            >
              <el-option
                :label="item.name"
                :value="item.code"
                v-for="(item, index) in chargePlanList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="地址查询">
            <div class="flex items-center">
              <el-input
                v-model="checkAddress"
                :disabled="disabled"
                placeholder="请输入需要查询的地址"
                style="width: 500px"
              ></el-input>
              <el-button
                type="primary"
                class="ml-30px"
                @click="handleCheckAddress"
                :disabled="disabled"
                >查询</el-button
              >
            </div>
          </el-form-item>
          <el-form-item>
            <div class="h-400px" style="overflow: hidden">
              <com-qq-map
                ref="qqMap"
                @latlng="handleMap"
                :coordinate="{ lat: ruleForm.addressLat, lng: ruleForm.addressLon }"
              ></com-qq-map>
            </div>
          </el-form-item>
          <el-row>
            <h3>绑定商家</h3>
            <el-col :span="15">
              <el-form-item label="商家">
                <div class="flex items-center">
                  <el-select
                    :disabled="disabled"
                    v-model="ruleForm.refBusiness"
                    placeholder="请选择"
                    style="width: 500px"
                  >
                    <el-option
                      :label="shop.businessName"
                      :value="shop.code"
                      v-for="(shop, index) in shopList"
                      :key="`${index}shop`"
                    ></el-option>
                  </el-select>
                  <el-button type="text" @click="handleUntieBusiness">解绑</el-button>
                </div>
              </el-form-item>
              <el-form-item label="分成类型">
                <el-radio-group v-model="ruleForm.divideType" :disabled="disabled">
                  <el-radio :label="1">扣除电费后分成</el-radio>
                  <el-radio :label="2">直接分成</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="分成">
                <el-input
                  v-model="ruleForm.businessDivide"
                  :disabled="disabled"
                  placeholder=""
                  style="width: 500px"
                >
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
              <el-form-item label="租金">
                <el-input
                  v-model="ruleForm.rent"
                  :disabled="disabled"
                  placeholder=""
                  style="width: 500px"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
              <el-form-item label="充电电费" prop="electricCharge">
                <el-input
                  :disabled="disabled"
                  placeholder=""
                  v-model="ruleForm.electricCharge"
                  style="width: 500px"
                >
                  <template slot="append">元/度</template>
                </el-input>
              </el-form-item>
              <el-form-item label="服务费">
                <el-input
                  v-model="ruleForm.serviceCharge"
                  :disabled="disabled"
                  placeholder=""
                  style="width: 500px"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="mtb-15px">
            <div class="flex items-center mb-10px">
              <h3>绑定合伙人</h3>
            </div>
            <!-- <el-col :span="24"> -->
            <div
              v-for="(item, index) in ruleForm.storePartners"
              :key="index"
              class="flex items-center justify-between"
            >
              <div>
                <el-form-item label="合伙人">
                  <div class="flex">
                    <el-select
                      v-model="item.refPartner"
                      :disabled="disabled"
                      placeholder=""
                      style="width: 500px"
                    >
                      <el-option
                        :label="opt.name"
                        :value="opt.code"
                        v-for="(opt, index) in partners"
                        :key="index"
                      ></el-option>
                    </el-select>
                    <div
                      v-if="type !== 'watch'"
                      class="ml-15px w-80px flex justify-between items-center"
                    >
                      <i
                        class="el-icon-circle-plus"
                        v-if="index === 0"
                        @click="handleAddPartner"
                      ></i>
                      <i class="el-icon-remove" @click="handleRemovePartner(index)"></i>
                    </div>
                  </div>
                </el-form-item>
                <el-row>
                  <el-col :span="14">
                    <el-form-item label="网点充值分成">
                      <el-date-picker
                        v-model="item.rechargeTime"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :disabled="disabled"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="handleRechargeTime"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="分成比">
                      <el-input
                        v-model="item.rechargeDivide"
                        :disabled="disabled"
                        placeholder=""
                        style="width: 180px"
                      >
                        <template slot="append">%</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="14">
                    <el-form-item label="网点充电分成">
                      <el-date-picker
                        v-model="item.ChargeTime"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :disabled="disabled"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd HH:mm:ss"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="分成比">
                      <el-input
                        v-model="item.divide"
                        :disabled="disabled"
                        placeholder=""
                        style="width: 180px"
                      >
                        <template slot="append">%</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-row>
          <el-row>
            <h3>充电桩设置</h3>
            <el-col :span="24">
              <el-form-item label="付费模式">
                <el-radio-group v-model="ruleForm.payMode" :disabled="disabled">
                  <el-radio :label="1">预付费</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="电费" prop="userElectricCharge">
                <el-input v-model="ruleForm.userElectricCharge" style="width: 200px">
                  <template slot="append">元/度</template>
                </el-input>
              </el-form-item>
              <el-form-item label="付费方式">
                <el-radio-group v-model="ruleForm.payType" :disabled="disabled">
                  <el-radio label="1">钱包</el-radio>
                </el-radio-group>
              </el-form-item>
              <div v-for="(item, index) in ruleForm.storeChargePlans" :key="index">
                <el-row>
                  <el-col :span="9">
                    <el-form-item label="功率">
                      <div class="flex items-center">
                        <el-input v-model="item.minPower" :disabled="disabled" style="width: 180px">
                          <template slot="append">W</template>
                        </el-input>
                        <div class="mlr-5px">-</div>
                        <el-input v-model="item.power" :disabled="disabled" style="width: 180px">
                          <template slot="append">W</template>
                        </el-input>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="金额">
                      <el-input :disabled="disabled" v-model="item.price" style="width: 180px">
                        <template slot="append">元/小时</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" v-if="type !== 'watch'">
                    <div class="flex items-center justify-center h-35px">
                      <i class="el-icon-circle-plus" v-if="index === 0" @click="handleAddPlans"></i>
                      <i class="el-icon-remove" v-else @click="handleRemove(index)"></i>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <div class="flex justify-end">
            <el-button @click="resetForm('ruleForm')">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')" :disabled="disabled"
              >确认</el-button
            >
          </div>
          <el-form-item> </el-form-item>
        </el-form>
      </div>
      <div v-if="activeName === '2'">
        <com-equ-search typeOfView="site" @search="handleSearch"> </com-equ-search>
        <div class="flex justify-end mb-15px">
          <el-button type="primary" @click="handleBatch('old')">绑定设备</el-button>
          <el-button type="primary" @click="handleBatch('new')">绑定新设备</el-button>
          <el-button type="primary" @click="handleReboot">重启设备</el-button>
          <el-button type="primary" @click="voiceSetting">语音设置</el-button>
          <el-button type="primary" @click="processedOtaUpgrade">OTA升级</el-button>
        </div>
        <com-equ-list
          :defaultParams="siteDefaultParams"
          typeOfView="site"
          ref="table"
        ></com-equ-list>
        <the-voice-dialog
          ref="voiceRef"
          @onSuccess="
            () => {
              $refs.table.init()
            }
          "
        />
      </div>
      <div v-if="activeName === '3'">
        <com-order-search
          typeOfView="site"
          @search="handleSearch"
          @onExport="handleExport"
        ></com-order-search>
        <com-order-list
          ref="table"
          :api="orderApi"
          :default-params="orderDefaultParams"
        ></com-order-list>
      </div>
    </com-card>
  </com-page>
</template>

<script>
import { orderListApi } from '@/api/order'
import { partnersListApi } from '@/api/partners'
import { addSiteApi, updateSiteApi, siteTypeApi, rebootEquApi } from '@/api/site'
import { siteOtaUpgradeApi } from '@/api/equ'
import { list } from '@/api/recharge-package'

import utils from 'my-tools-library'
import theVoiceDialog from './components/the-voice-dialog'

export default {
  components: { theVoiceDialog },
  data() {
    return {
      orderApi: orderListApi,
      orderDefaultParams: {},
      type: '',
      activeName: '1',
      disabled: false,
      regionId: [],
      region: '',
      checkAddress: '',
      ruleForm: {
        pwd: '', // 密码
        photo: '', // 网点图片
        name: '', // 网点名称
        area: '', // 所在区域
        address: '', // 地址
        projectLeader: '', // 负责人
        effectiveTime: '', // 生效时间
        expireTime: '', // 到期时间
        fullPrepayAmount: '', // 充满自停预付费金额
        rent: '', // 租金
        refBusiness: '', // 商家
        serviceCharge: '', // 服务费
        payType: '1', // 付费方式
        payMode: 1, // 付费模式
        businessDivide: '', // 分成
        addressLon: '', // 经度
        addressLat: '', // 纬度
        electricCharge: '', // 电费
        storePartners: [{}],
        storeChargePlans: [
          {
            price: '',
            power: '',
            minPower: ''
          }
        ],
        code: '',
        id: '',
        areaCodes: [],
        contactNumber: '', // 联系电话
        type: '', // 网点类型
        divideType: 1, // 分成类型
        number: '', // 网点编号
        refChargePlanBatch: '', // 充值套餐
      },
      shopList: [],
      partners: [],
      rules: {
        name: [{ required: true, message: '请输入网点名称', trigger: 'blur' }],
        pwd: [{ required: false, message: '请输入网点密码', trigger: 'blur' }],
        projectLeader: [{ required: true, message: '请输入负责人', trigger: 'blur' }],
        contactNumber: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        area: [{ required: true, message: '请选择所在地域', trigger: 'blur' }],
        type: [{ required: true, message: '请选择网点类型', trigger: 'blur' }],
        address: [{ required: true, message: '请填写地址', trigger: 'blur' }],
        effectiveTime: [{ required: true, message: '请选择生效时间', trigger: 'blur' }],
        expireTime: [{ required: true, message: '请选择到期时间', trigger: 'blur' }],
        businessDivide: [{ required: true, message: '请填写分成', trigger: 'blur' }],
        rent: [{ required: true, message: '请填写租金', trigger: 'blur' }],
        serviceCharge: [{ required: true, message: '请填写服务费', trigger: 'blur' }],
        payType: [{ required: true, message: '请选择付费方式', trigger: 'blur' }],
        electricCharge: [{ required: true, message: '请填写充电电费', trigger: 'blur' }],
        fullPrepayAmount: [{ required: true, message: '请填写预付费', trigger: 'blur' }],
        refBusiness: [{ required: true, message: '请选择商家', trigger: 'blur' }],
        photo: [{ required: true, message: '请上传网点图片', trigger: 'blur' }],
        userElectricCharge: [{ required: true, message: '请填写电费', trigger: 'blur' }],
        refChargePlanBatch: [{ required: true, message: '请选择充值套餐', trigger: 'blur' }]
      },
      siteDefaultParams: {},
      siteType: [],
      chargePlanList: [],
      exportQuery: {}
    }
  },
  watch: {
    regionId: {
      handler(val) {
        if (val.length) {
          this.ruleForm.area = val.at(-1)
          this.ruleForm.areaCodes = val
        }
      }
    }
  },
  methods: {
    getShop() {
      const param = {
        pageIndex: 1,
        pageSize: 10000,
        type: 2
      }
      partnersListApi(param).then((res) => {
        const { records } = res.data
        this.shopList = records
      })
    },

    getSiteType() {
      const params = {
        pageIndex: 1,
        pageSize: 10000
      }
      siteTypeApi(params).then((res) => {
        const { records } = res.data
        this.siteType = records
        console.log('网点类型 :>> ', this.siteType)
      })
    },

    getChargePlans() {
      const params = {
        pageIndex: 1,
        pageSize: 10000
      }
      list(params).then((res) => {
        const { records } = res.data
        this.chargePlanList = records
        console.log('充值套餐 :>> ', this.chargePlanList)
      })
    },

    getPartners() {
      const param = {
        pageIndex: 1,
        pageSize: 10000,
        type: 1
      }
      partnersListApi(param).then((res) => {
        const { records } = res.data
        this.partners = records
      })
    },
    postImg(url) {
      this.ruleForm.photo = url
    },
    delImg() {
      this.ruleForm.photo = ''
    },
    handleAddPartner() {
      const param = {
        refPartner: '',
        divide: ''
      }
      this.ruleForm.storePartners.push(param)
    },
    handleRemovePartner(i) {
      this.ruleForm.storePartners.splice(i, 1)
    },
    handleRemove(i) {
      this.ruleForm.storeChargePlans.splice(i, 1)
    },
    handleAddPlans() {
      const param = {
        price: '',
        power: '',
        minPower: ''
      }
      this.ruleForm.storeChargePlans.push(param)
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.push({ name: 'site-index' })
    },

    submitParams() {
      const params = utils.deepCopy(this.ruleForm)
      // 分成要除以100提交

      if (params.businessDivide) params.businessDivide /= 100
      if (params.storePartners.length) {
        params.storePartners.map((parent) => {
          if (parent.divide) parent.divide /= 100
          if (parent.rechargeDivide) parent.rechargeDivide /= 100

          // 处理网点充值分成
          if (parent.rechargeTime && parent.rechargeTime.length) {
            console.log('处理网点充值分成 :>> ', parent.rechargeTime)
            // eslint-disable-next-line prefer-destructuring
            parent.rechargeEffectiveTime = parent.rechargeTime[0]
            // eslint-disable-next-line prefer-destructuring
            parent.rechargeExpireTime = parent.rechargeTime[1]
          }
          delete parent.rechargeTime
          // 处理网点充电分成
          if (parent.ChargeTime && parent.ChargeTime.length) {
            console.log('处理网点充电分成 :>> ', parent.ChargeTime)
            // eslint-disable-next-line prefer-destructuring
            parent.effectiveTime = parent.ChargeTime[0]
            // eslint-disable-next-line prefer-destructuring
            parent.expireTime = parent.ChargeTime[1]
          }
          delete parent.ChargeTime
          return parent
        })
      }

      console.log('数据 :>> ', params)
      return utils.cleanObject(params)
    },
    handleCreated() {
      // this.submitParams()
      this.disabled = true
      addSiteApi(this.submitParams())
        .then((res) => {
          this.disabled = false
          if (res.status === 200) this.$router.back()
        })
        .catch(() => {
          this.disabled = false
          this.$message.error('请检查填写信息')
        })
    },

    handleUpdate() {
      this.disabled = true
      updateSiteApi(this.submitParams())
        .then((res) => {
          this.disabled = false
          if (res.status === 200) {
            this.$router.push({ name: 'site-index', params: { type: 'update' } })
          }
        })
        .catch(() => {
          this.disabled = false
        })
    },
    submitForm(formName) {
      if (this.ruleForm.storeChargePlans.length < 2) {
        this.$message.error('请输入最少两个收费阶段')
        return
      }
      // eslint-disable-next-line consistent-return
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // eslint-disable-next-line no-unused-expressions
          this.type === 'created' ? this.handleCreated() : this.handleUpdate()
        }
      })
    },

    handleRechargeTime(val) {
      console.log('val :>> ', val)
    },
    handleAddress(val) {
      console.log('val :>> ', this.region, val)
      this.$refs.mapRef.setAddress(this.region, val)
    },
    handleCheckAddress() {
      this.$refs.qqMap.setAddress(this.checkAddress)
      this.ruleForm.address = this.checkAddress
    },
    handleMap(val) {
      console.log('经纬度 :>> ', val)
      this.ruleForm.addressLat = val.lat
      this.ruleForm.addressLon = val.lng
    },
    handleSearch(val) {
      this.exportQuery = { ...val }
      this.$refs.table.search(val)
    },
    handleUntieBusiness() {
      this.ruleForm.refBusiness = ''
      this.ruleForm.serviceCharge = ''
      this.ruleForm.businessDivide = ''
      this.ruleForm.rent = ''
    },
    handleBatch(val) {
      const param = {
        type: val
      }
      this.$refs.table.handleBind(param)
    },
    // 重启设备
    handleReboot() {
      this.$confirm('是否确认重启全部设备?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const params = {
            refStore: this.siteDefaultParams.refStore
          }
          const res = await rebootEquApi(params)
          if (res) {
            this.$message.success(res.desc)
            this.$refs.table.init()
          }
        })
        .catch(() => {})
    },
    voiceSetting() {
      this.$refs.voiceRef.open(this.siteDefaultParams.refStore)
    },
    handleExport() {
      const params = {
        ...this.orderDefaultParams,
        ...this.exportQuery
      }
      const obj = JSON.parse(JSON.stringify(params))
      let i = ''
      let url = ''
      // eslint-disable-next-line prefer-template, guard-for-in, no-restricted-syntax
      for (i in obj) url += '&' + i + '=' + obj[i]
      const downloadUrl = `${process.env.VUE_APP_REQUEST_URL}/chargePieOrder/exportExcel?${url}`
      console.log('host :>> ', downloadUrl)
      utils.download(downloadUrl, '网点订单列表')
    },
    processedOtaUpgrade() {
      this.$confirm('确定要让设备查询OTA升级吗? 若有新版本设备将启动更新程序', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(
        async () => {
          const params = {
            refStore: this.siteDefaultParams.refStore
          }
          await siteOtaUpgradeApi(params)
          this.$message({
            type: 'success',
            message: '操作成功'
          })
        },
        () => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        }
      )
    }
  },
  created() {
    this.getShop()
    this.getPartners()
    this.getSiteType()
    this.getChargePlans()
    const { row, type } = this.$route.params
    console.log('row :>> ', row, type)
    if (utils.isEmptyObj(this.$route.params)) {
      this.$router.push({ name: 'site-index' })
      return
    }
    this.type = type
    if (type === 'created') {
      return
    }

    this.ruleForm = utils.deepCopy(row)
    this.siteDefaultParams.refStore = row.code
    this.regionId = row.areaCodes
    // 分成要乘以100显示
    if (this.ruleForm.businessDivide) this.ruleForm.businessDivide *= 100
    if (this.ruleForm.storePartners.length) {
      this.ruleForm.storePartners.map((parent) => {
        if (parent.divide) parent.divide *= 100
        if (parent.rechargeDivide) parent.rechargeDivide *= 100
        // 回显充电分成时间
        if (parent.effectiveTime) {
          const array = []
          array.push(parent.effectiveTime, parent.expireTime)
          this.$set(parent, 'ChargeTime', array)
        }
        // 回显充值分成时间
        if (parent.rechargeEffectiveTime) {
          const array = []
          array.push(parent.rechargeEffectiveTime, parent.rechargeExpireTime)
          this.$set(parent, 'rechargeTime', array)
        }
        delete parent.storeCodes
        return parent
      })

      console.log('this.ruleForm.storePartners :>> ', this.ruleForm.storePartners)
    }
    if (type === 'watch') {
      this.disabled = true
      this.orderDefaultParams = {
        refStore: row.code
      }
    }
    if (type === 'edit') {
      console.log('edit :>> ', row)
      this.disabled = false

      if (!this.ruleForm.storePartners.length) {
        this.ruleForm.storePartners = [{ refPartner: '', divide: '' }]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.site-edit_wrapper {
  :deep(.el-radio__inner) {
    border-radius: 2px;
  }

  :deep(.el-radio__input.is-checked) .el-radio__inner::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 0;
    display: block;
    width: 10px;
    height: 5px;
    text-align: center;
    vertical-align: middle;
    background: none;
    border: 1px solid white;
    border-top: transparent;
    border-right: transparent;
    border-radius: 0;
    transform: rotate(-45deg);
  }
}
</style>
